export default "__VITE_ASSET__B4SMTIW2__"